import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
@Component({
	selector: 'pcm-ui-day-time',
	templateUrl: './ui-day-time.component.html',
	styleUrls: ['./ui-day-time.component.scss']
})
export class UiDayTimeComponent implements OnInit {
	@Input() dayTime;

	days = [{'value': 'Monday'},
			{'value': 'Tuesday'},
			{'value': 'Wednesday'},
			{'value': 'Thursday'},
			{'value': 'Friday'},
			{'value': 'Saturday'},
			{'value': 'Sunday'}];

	showWeek = true;
	constructor(public configService: ConfigService) {}

	ngOnInit() {
		if (!this.dayTime.week) {
			this.showWeek = false;
		}
	}

	updateTimezone(name) {
		const selectedTZ = this.configService.timezones.filter(tz => {
			return tz.name === name;
		});
		if (selectedTZ) {
			this.dayTime.timezone.value = selectedTZ[0].value;
		}
	}

	updateWeek(event) {
		if (event.target.checked) {
			this.dayTime.week = 'next';
		} else {
			this.dayTime.week = 'current';
		}
	}

	isChecked() {
		return this.dayTime.week === 'next';
	}


}
